"use strict";
// NOTE these constants are not exported by the package, and are only usable within the package!
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultOccupationString = exports.defaultPersonNameString = exports.defaultNullableString = exports.defaultOptionalString = exports.defaultString = exports.REGEX = exports.MAX_PERSON_NAME_LENGTH = exports.MAX_DEFAULT_STRING_LENGTH = exports.MIN_DEFAULT_STRING_LENGTH = void 0;
const zod_1 = require("zod");
exports.MIN_DEFAULT_STRING_LENGTH = 1;
exports.MAX_DEFAULT_STRING_LENGTH = 255;
exports.MAX_PERSON_NAME_LENGTH = 50;
exports.REGEX = {
    addressNumber: /^(?:[A-Za-z] ?)?[A-Za-z]?\d+(?:(-|\w)[\d]+)?[A-Za-z]?(?: \d+\/\d+)?$/,
    addressStreet: /^[\dA-Za-z]+(?:[\dA-Za-z- ./#]+)?$/,
    defaultString: /(?!\s).+/,
    digitsOnly: /^\d+$/,
    digitsAndLettersOnly: /^[0-9A-Za-z]+$/,
    iso8601Date: /^(\d{4})(?:-(\d{2}))??(?:-(\d{2}))??$/,
    iso8601DateTime: /^(\d{4})(?:-(\d{2}))??(?:-(\d{2}))??T(\d{2}):(\d{2})(?::(\d{2}))??(?:\.(\d+))??((?:[\+\-]{1}\d{2}:\d{2})|Z)??$/,
    nonWhiteSpace: /^\S+$/,
    occupation: /^(?![\s\d])[\p{P}\p{Z}\p{L}\d]{4,105}$/u,
    phoneNumber: /^\(?\d{3}\)?[-\. ]?\d{3}[-\. ]?\d{4}(?: ext\. \d{1,5}|\d{1,5})?$/,
    unicodeLettersSeparatedBySpacesOrHyphens: /^(?:\p{L}[ '-]?)+$/u,
};
exports.defaultString = zod_1.z
    .string()
    .min(exports.MIN_DEFAULT_STRING_LENGTH)
    .max(exports.MAX_DEFAULT_STRING_LENGTH)
    .regex(exports.REGEX.defaultString);
exports.defaultOptionalString = zod_1.z.nullable(exports.defaultString).optional();
exports.defaultNullableString = zod_1.z.nullable(exports.defaultString);
exports.defaultPersonNameString = zod_1.z
    .string()
    .min(exports.MIN_DEFAULT_STRING_LENGTH)
    .max(exports.MAX_PERSON_NAME_LENGTH)
    .regex(exports.REGEX.unicodeLettersSeparatedBySpacesOrHyphens);
exports.defaultOccupationString = zod_1.z.string().min(4).max(128).regex(exports.REGEX.occupation);
